// extracted by mini-css-extract-plugin
module.exports = {"root":"_7b2d0eaa85b20c3afa70cf1ebb25ba36"};